<div class="row">
  <div class="col-sm-6">
    <h2>{{ 'KPI.CHAIN_REPORTS.TITLE' | translate }} <span *ngIf="chainName">— {{ chainName }}</span></h2>
  </div>
  <div class="col-sm-6">
    <button type="button" class="btn btn-secondary px-4" style="float: right" (click)="goBack()">
      {{ backLabel }}
    </button>
  </div>
</div>

<!-- Filter Bar -->
<div class="col-12" style="margin-top: 20px">
  <nb-card>
    <nb-card-body>
      <app-report-filter-bar
        [showStoreFilter]="true"
        [showExportDetailLevel]="true"
        [stores]="chainStores"
        [disabled]="reportsLoading || categoryLoading || categoryExportLoading"
        (filterChange)="onFilterChange($event)"
        (exportRequested)="onExport($event)">
      </app-report-filter-bar>
      <div class="text-muted small mt-1">{{ 'KPI.CHAIN_REPORTS.EXPORT_SUMMARY_HINT' | translate }}</div>
    </nb-card-body>
  </nb-card>
</div>

<!-- Empty State -->
<div class="col-12" style="margin-top: 20px" *ngIf="!reportsLoading && !hasData && stores.length === 0">
  <nb-card>
    <nb-card-body class="text-center py-5">
      <nb-icon icon="bar-chart-outline" class="large-icon text-muted mb-3"></nb-icon>
      <h4>{{ 'KPI.CHAIN_REPORTS.NO_DATA_TITLE' | translate }}</h4>
      <p class="text-muted mb-0">{{ 'KPI.CHAIN_REPORTS.NO_DATA_HINT' | translate }}</p>
    </nb-card-body>
  </nb-card>
</div>

<!-- Summary Cards -->
<div class="row" style="margin-top: 20px" *ngIf="hasData || stores.length > 0">
  <div class="col-sm-4">
    <nb-card class="summary-card">
      <nb-card-body class="text-center">
        <div class="summary-label">{{ 'KPI.CHAIN_REPORTS.TOTAL_REVENUE' | translate }}</div>
        <div class="summary-value">{{ formatCurrency(totals.totalRevenue) }}</div>
        <small *ngIf="previousPeriodComparison.available && previousPeriodComparison.totalRevenue"
          [class]="deltaClass(previousPeriodComparison.totalRevenue.deltaPct)">
          {{ formatDelta(previousPeriodComparison.totalRevenue.deltaPct) }} {{ 'KPI.CHAIN_REPORTS.VS_PREVIOUS' | translate }}
        </small>
      </nb-card-body>
    </nb-card>
  </div>
  <div class="col-sm-4">
    <nb-card class="summary-card">
      <nb-card-body class="text-center">
        <div class="summary-label">{{ 'KPI.CHAIN_REPORTS.TOTAL_ORDERS' | translate }}</div>
        <div class="summary-value">{{ totals.totalOrders || 0 }}</div>
        <small *ngIf="previousPeriodComparison.available && previousPeriodComparison.totalOrders"
          [class]="deltaClass(previousPeriodComparison.totalOrders.deltaPct)">
          {{ formatDelta(previousPeriodComparison.totalOrders.deltaPct) }} {{ 'KPI.CHAIN_REPORTS.VS_PREVIOUS' | translate }}
        </small>
      </nb-card-body>
    </nb-card>
  </div>
  <div class="col-sm-4">
    <nb-card class="summary-card">
      <nb-card-body class="text-center">
        <div class="summary-label">{{ 'KPI.CHAIN_REPORTS.AVG_ORDER_VALUE' | translate }}</div>
        <div class="summary-value">{{ formatCurrency(totals.avgOrderValue) }}</div>
        <small *ngIf="previousPeriodComparison.available && previousPeriodComparison.avgOrderValue"
          [class]="deltaClass(previousPeriodComparison.avgOrderValue.deltaPct)">
          {{ formatDelta(previousPeriodComparison.avgOrderValue.deltaPct) }} {{ 'KPI.CHAIN_REPORTS.VS_PREVIOUS' | translate }}
        </small>
      </nb-card-body>
    </nb-card>
  </div>
</div>

<!-- Returns & Voids -->
<div class="row" style="margin-top: 20px" *ngIf="hasData || stores.length > 0">
  <div class="col-sm-6">
    <nb-card>
      <nb-card-header>{{ 'KPI.CHAIN_REPORTS.RETURNS' | translate }}</nb-card-header>
      <nb-card-body class="d-flex justify-content-between">
        <div>
          <div class="text-muted">{{ 'KPI.CHAIN_REPORTS.COUNT' | translate }}</div>
          <strong>{{ returnsAndVoids.returnsCount || 0 }}</strong>
        </div>
        <div class="text-end">
          <div class="text-muted">{{ 'KPI.CHAIN_REPORTS.AMOUNT' | translate }}</div>
          <strong>{{ formatCurrency(returnsAndVoids.returnsAmount) }}</strong>
        </div>
      </nb-card-body>
    </nb-card>
  </div>
  <div class="col-sm-6">
    <nb-card>
      <nb-card-header>{{ 'KPI.CHAIN_REPORTS.VOIDS' | translate }}</nb-card-header>
      <nb-card-body class="d-flex justify-content-between">
        <div>
          <div class="text-muted">{{ 'KPI.CHAIN_REPORTS.COUNT' | translate }}</div>
          <strong>{{ returnsAndVoids.voidsCount || 0 }}</strong>
        </div>
        <div class="text-end">
          <div class="text-muted">{{ 'KPI.CHAIN_REPORTS.AMOUNT' | translate }}</div>
          <strong>{{ formatCurrency(returnsAndVoids.voidsAmount) }}</strong>
        </div>
      </nb-card-body>
    </nb-card>
  </div>
</div>

<!-- Daily Trend Chart -->
<div class="col-12" style="margin-top: 20px" *ngIf="dailyTrend.length > 0">
  <nb-card>
    <nb-card-header>{{ 'KPI.CHAIN_REPORTS.DAILY_TREND' | translate }}</nb-card-header>
    <nb-card-body>
      <div style="display: block; min-height: 300px;">
        <canvas baseChart #trendChart="base-chart"
          [data]="trendChartData"
          [options]="trendChartOptions"
          [type]="trendChartType">
        </canvas>
      </div>
    </nb-card-body>
  </nb-card>
</div>

<!-- Per-store Breakdown -->
<div class="col-12" style="margin-top: 20px">
  <nb-card>
    <nb-card-header>{{ 'KPI.CHAIN_REPORTS.STORE_BREAKDOWN' | translate }}</nb-card-header>
    <nb-card-body>
      <table class="table text-center">
        <thead>
          <tr>
            <th>{{ 'KPI.CHAIN_REPORTS.STORE_NAME' | translate }}</th>
            <th style="cursor: pointer" (click)="toggleSort()">
              {{ 'KPI.DASHBOARD.REVENUE' | translate }}
              <nb-icon [icon]="sortDir === 'desc' ? 'arrow-downward-outline' : 'arrow-upward-outline'"></nb-icon>
            </th>
            <th>{{ 'KPI.CHAIN_REPORTS.ORDERS' | translate }}</th>
            <th>{{ 'KPI.CHAIN_REPORTS.AVG_ORDER_VALUE' | translate }}</th>
            <th>{{ 'KPI.CHAIN_REPORTS.PCT_OF_CHAIN' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let store of sortedStores">
            <td>{{ store.storeName }}</td>
            <td>{{ formatCurrency(store.totalRevenue) }}</td>
            <td>{{ store.orderCount || 0 }}</td>
            <td>{{ formatCurrency(store.avgOrderValue) }}</td>
            <td>
              <nb-badge *ngIf="store.pctOfChain != null" status="info" [text]="store.pctOfChain.toFixed(1) + '%'"></nb-badge>
              <span *ngIf="store.pctOfChain == null">-</span>
            </td>
          </tr>
          <tr *ngIf="sortedStores.length === 0">
            <td colspan="5" class="text-center" style="padding: 30px; color: #888">
              {{ 'KPI.CHAIN_REPORTS.NO_DATA' | translate }}
            </td>
          </tr>
        </tbody>
      </table>
    </nb-card-body>
  </nb-card>
</div>

<!-- BA Breakdown -->
<div class="col-12" style="margin-top: 20px" *ngIf="categoryLoading">
  <nb-card>
    <nb-card-header>{{ 'KPI.CHAIN_REPORTS.BA_BREAKDOWN' | translate }}</nb-card-header>
    <nb-card-body class="text-center py-4">
      <nb-spinner size="medium"></nb-spinner>
    </nb-card-body>
  </nb-card>
</div>

<div class="col-12" style="margin-top: 20px" *ngIf="!categoryLoading && baBreakdown.length > 0">
  <nb-card>
    <nb-card-header class="d-flex flex-wrap align-items-center justify-content-between gap-2">
      <span>{{ 'KPI.CHAIN_REPORTS.BA_BREAKDOWN' | translate }}</span>
      <div class="export-actions d-flex align-items-center flex-wrap gap-2">
        <div class="btn-group btn-group-sm" role="group">
          <button type="button" class="btn"
            [class.btn-secondary]="categoryExportDetailLevel === 'summary'"
            [class.btn-outline-secondary]="categoryExportDetailLevel !== 'summary'"
            [disabled]="reportsLoading || categoryLoading || categoryExportLoading"
            (click)="categoryExportDetailLevel = 'summary'">
            {{ 'KPI.FILTER_BAR.EXPORT_DETAIL_SUMMARY' | translate }}
          </button>
          <button type="button" class="btn"
            [class.btn-secondary]="categoryExportDetailLevel === 'detailed'"
            [class.btn-outline-secondary]="categoryExportDetailLevel !== 'detailed'"
            [disabled]="reportsLoading || categoryLoading || categoryExportLoading"
            (click)="categoryExportDetailLevel = 'detailed'">
            {{ 'KPI.FILTER_BAR.EXPORT_DETAIL_DETAILED' | translate }}
          </button>
        </div>
        <span class="text-muted small">{{ 'KPI.CHAIN_REPORTS.EXPORT_PRODUCT_BREAKDOWN' | translate }}:</span>
        <button *ngFor="let fmt of exportFormats" type="button" class="btn btn-sm btn-outline-success"
          [disabled]="reportsLoading || categoryLoading || categoryExportLoading"
          (click)="onCategoryExport(fmt)">
          <nb-icon icon="download-outline"></nb-icon> {{ fmt | uppercase }}
        </button>
      </div>
    </nb-card-header>
    <nb-card-body class="p-0">
      <div class="ba-list">
        <div class="ba-row" *ngFor="let ba of baBreakdown">
          <div class="ba-header" (click)="toggleBa(ba.baId)">
            <div class="ba-name">
              <nb-icon [icon]="isExpanded(ba.baId) ? 'chevron-down-outline' : 'chevron-right-outline'"></nb-icon>
              <strong>{{ ba.baName }}</strong>
            </div>
            <div class="ba-metrics">
              <span>{{ formatCurrency(ba.totalRevenue) }}</span>
              <span class="text-muted ms-3">{{ 'KPI.CHAIN_REPORTS.QUANTITY' | translate }}: {{ formatNumber(ba.totalQuantity) }}</span>
              <span class="text-muted ms-3">{{ 'KPI.CHAIN_REPORTS.STORES' | translate }}: {{ ba.storeCount || 0 }}</span>
            </div>
          </div>
          <div class="varegruppe-table" *ngIf="isExpanded(ba.baId)">
            <div class="table-responsive product-table-scroll mb-2">
              <table class="table table-sm mb-0 product-table">
                <thead>
                  <tr>
                    <th>{{ 'KPI.ANALYTICS.EAN' | translate }}</th>
                    <th>{{ 'KPI.ANALYTICS.SKU' | translate }}</th>
                    <th>{{ 'KPI.ANALYTICS.PRODUCT' | translate }}</th>
                    <th class="text-end">{{ 'KPI.ANALYTICS.QUANTITY' | translate }}</th>
                    <th class="text-end">{{ 'KPI.ANALYTICS.TAX_RATE' | translate }}</th>
                    <th class="text-end">{{ 'KPI.ANALYTICS.UNIT_COST_PRICE_INCL_TAX' | translate }}</th>
                    <th class="text-end">{{ 'KPI.ANALYTICS.UNIT_SELLING_PRICE_INCL_TAX' | translate }}</th>
                    <th class="text-end">{{ 'KPI.ANALYTICS.UNIT_PROFIT_INCL_TAX' | translate }}</th>
                    <th class="text-end">{{ 'KPI.ANALYTICS.TOTAL_INCL_TAX' | translate }}</th>
                    <th class="text-end">{{ 'KPI.ANALYTICS.TOTAL_PROFIT_INCL_TAX' | translate }}</th>
                    <th class="text-end">{{ 'KPI.ANALYTICS.UNIT_COST_PRICE_EX_TAX' | translate }}</th>
                    <th class="text-end">{{ 'KPI.ANALYTICS.UNIT_SELLING_PRICE_EX_TAX' | translate }}</th>
                    <th class="text-end">{{ 'KPI.ANALYTICS.UNIT_PROFIT_EX_TAX' | translate }}</th>
                    <th class="text-end">{{ 'KPI.ANALYTICS.TOTAL_EX_TAX' | translate }}</th>
                    <th class="text-end">{{ 'KPI.ANALYTICS.TOTAL_PROFIT_EX_TAX' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="subtotal-row">
                    <td>-</td>
                    <td>-</td>
                    <td><strong>{{ ba.baName }} ({{ 'KPI.ANALYTICS.SUBTOTAL' | translate }})</strong></td>
                    <td class="text-end">{{ formatNumber(ba.totalQuantity) }}</td>
                    <td class="text-end">{{ formatTaxRate(ba.taxRatePercent) }}</td>
                    <td class="text-end">{{ formatMoney(ba.unitCostPriceInclTax, true) }}</td>
                    <td class="text-end">{{ formatMoney(ba.unitSellingPriceInclTax) }}</td>
                    <td class="text-end">{{ formatMoney(ba.unitProfitInclTax, true) }}</td>
                    <td class="text-end">{{ formatMoney(ba.totalInclTax) }}</td>
                    <td class="text-end">{{ formatMoney(ba.totalProfitInclTax, true) }}</td>
                    <td class="text-end">{{ formatMoney(ba.unitCostPriceExTax, true) }}</td>
                    <td class="text-end">{{ formatMoney(ba.unitSellingPriceExTax) }}</td>
                    <td class="text-end">{{ formatMoney(ba.unitProfitExTax, true) }}</td>
                    <td class="text-end">{{ formatMoney(ba.totalExTax) }}</td>
                    <td class="text-end">{{ formatMoney(ba.totalProfitExTax, true) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <table class="table table-sm mb-0">
              <thead>
                <tr>
                  <th>{{ 'KPI.ANALYTICS.VAREGRUPPE' | translate }}</th>
                  <th class="text-end">{{ 'KPI.DASHBOARD.REVENUE' | translate }}</th>
                  <th class="text-end">{{ 'KPI.CHAIN_REPORTS.QUANTITY' | translate }}</th>
                  <th class="text-end">{{ 'KPI.ANALYTICS.PRODUCTS' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let vg of ba.varegrupper || []">
                  <tr class="vg-row" (click)="toggleVg(ba.baId, vg.categoryId)">
                    <td>
                      <nb-icon [icon]="isVgExpanded(ba.baId, vg.categoryId) ? 'chevron-down-outline' : 'chevron-right-outline'"></nb-icon>
                      {{ vg.categoryName }}
                    </td>
                    <td class="text-end">{{ formatCurrency(vg.totalRevenue) }}</td>
                    <td class="text-end">{{ formatNumber(vg.totalQuantity) }}</td>
                    <td class="text-end">{{ formatNumber(vg.uniqueProductCount) }}</td>
                  </tr>
                  <tr *ngIf="isVgExpanded(ba.baId, vg.categoryId)">
                    <td colspan="4" class="product-detail-cell">
                      <div class="table-responsive product-table-scroll" *ngIf="vg.products?.length">
                        <table class="table table-sm mb-0 product-table">
                          <thead>
                            <tr>
                              <th>{{ 'KPI.ANALYTICS.EAN' | translate }}</th>
                              <th>{{ 'KPI.ANALYTICS.SKU' | translate }}</th>
                              <th>{{ 'KPI.ANALYTICS.PRODUCT' | translate }}</th>
                              <th class="text-end">{{ 'KPI.ANALYTICS.QUANTITY' | translate }}</th>
                              <th class="text-end">{{ 'KPI.ANALYTICS.TAX_RATE' | translate }}</th>
                              <th class="text-end">{{ 'KPI.ANALYTICS.UNIT_COST_PRICE_INCL_TAX' | translate }}</th>
                              <th class="text-end">{{ 'KPI.ANALYTICS.UNIT_SELLING_PRICE_INCL_TAX' | translate }}</th>
                              <th class="text-end">{{ 'KPI.ANALYTICS.UNIT_PROFIT_INCL_TAX' | translate }}</th>
                              <th class="text-end">{{ 'KPI.ANALYTICS.TOTAL_INCL_TAX' | translate }}</th>
                              <th class="text-end">{{ 'KPI.ANALYTICS.TOTAL_PROFIT_INCL_TAX' | translate }}</th>
                              <th class="text-end">{{ 'KPI.ANALYTICS.UNIT_COST_PRICE_EX_TAX' | translate }}</th>
                              <th class="text-end">{{ 'KPI.ANALYTICS.UNIT_SELLING_PRICE_EX_TAX' | translate }}</th>
                              <th class="text-end">{{ 'KPI.ANALYTICS.UNIT_PROFIT_EX_TAX' | translate }}</th>
                              <th class="text-end">{{ 'KPI.ANALYTICS.TOTAL_EX_TAX' | translate }}</th>
                              <th class="text-end">{{ 'KPI.ANALYTICS.TOTAL_PROFIT_EX_TAX' | translate }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr class="subtotal-row">
                              <td>-</td>
                              <td>-</td>
                              <td><strong>{{ vg.categoryName }} ({{ 'KPI.ANALYTICS.SUBTOTAL' | translate }})</strong></td>
                              <td class="text-end">{{ formatNumber(vg.totalQuantity) }}</td>
                              <td class="text-end">{{ formatTaxRate(vg.taxRatePercent) }}</td>
                              <td class="text-end">{{ formatMoney(vg.unitCostPriceInclTax, true) }}</td>
                              <td class="text-end">{{ formatMoney(vg.unitSellingPriceInclTax) }}</td>
                              <td class="text-end">{{ formatMoney(vg.unitProfitInclTax, true) }}</td>
                              <td class="text-end">{{ formatMoney(vg.totalInclTax) }}</td>
                              <td class="text-end">{{ formatMoney(vg.totalProfitInclTax, true) }}</td>
                              <td class="text-end">{{ formatMoney(vg.unitCostPriceExTax, true) }}</td>
                              <td class="text-end">{{ formatMoney(vg.unitSellingPriceExTax) }}</td>
                              <td class="text-end">{{ formatMoney(vg.unitProfitExTax, true) }}</td>
                              <td class="text-end">{{ formatMoney(vg.totalExTax) }}</td>
                              <td class="text-end">{{ formatMoney(vg.totalProfitExTax, true) }}</td>
                            </tr>
                            <ng-container *ngFor="let product of vg.products">
                              <tr class="product-row" (click)="toggleProduct(ba.baId, vg.categoryId, product.productId)">
                                <td>
                                  <nb-icon [icon]="isProductExpanded(ba.baId, vg.categoryId, product.productId) ? 'chevron-down-outline' : 'chevron-right-outline'"></nb-icon>
                                  {{ product.ean || '-' }}
                                </td>
                                <td>{{ product.sku || '-' }}</td>
                                <td>{{ product.name }}</td>
                                <td class="text-end">{{ formatNumber(product.totalQuantity) }}</td>
                                <td class="text-end">{{ formatTaxRate(product.taxRatePercent) }}</td>
                                <td class="text-end">{{ formatMoney(product.unitCostPriceInclTax, true) }}</td>
                                <td class="text-end">{{ formatMoney(product.unitSellingPriceInclTax) }}</td>
                                <td class="text-end">{{ formatMoney(product.unitProfitInclTax, true) }}</td>
                                <td class="text-end">{{ formatMoney(product.totalInclTax) }}</td>
                                <td class="text-end">{{ formatMoney(product.totalProfitInclTax, true) }}</td>
                                <td class="text-end">{{ formatMoney(product.unitCostPriceExTax, true) }}</td>
                                <td class="text-end">{{ formatMoney(product.unitSellingPriceExTax) }}</td>
                                <td class="text-end">{{ formatMoney(product.unitProfitExTax, true) }}</td>
                                <td class="text-end">{{ formatMoney(product.totalExTax) }}</td>
                                <td class="text-end">{{ formatMoney(product.totalProfitExTax, true) }}</td>
                              </tr>
                              <tr *ngIf="isProductExpanded(ba.baId, vg.categoryId, product.productId)" class="product-sales-row">
                                <td colspan="15" class="product-sales-cell">
                                  <div class="product-sales-panel">
                                    <div class="product-sales-heading text-muted small mb-2">{{ 'KPI.ANALYTICS.INDIVIDUAL_SALES' | translate }}</div>
                                    <div *ngIf="productSalesCache[productKey(ba.baId, vg.categoryId, product.productId)]?.loading && !productSalesCache[productKey(ba.baId, vg.categoryId, product.productId)]?.rows?.length"
                                      class="text-center py-2">
                                      <nb-spinner size="tiny"></nb-spinner>
                                    </div>
                                    <div *ngIf="productSalesCache[productKey(ba.baId, vg.categoryId, product.productId)]?.error"
                                      class="text-danger py-2">
                                      {{ 'KPI.ANALYTICS.LOAD_SALES_ERROR' | translate }}
                                    </div>
                                    <div *ngIf="!productSalesCache[productKey(ba.baId, vg.categoryId, product.productId)]?.loading
                                      && !productSalesCache[productKey(ba.baId, vg.categoryId, product.productId)]?.error
                                      && !productSalesCache[productKey(ba.baId, vg.categoryId, product.productId)]?.rows?.length"
                                      class="text-muted py-2">
                                      {{ 'KPI.ANALYTICS.NO_SALES_IN_PERIOD' | translate }}
                                    </div>
                                    <table *ngIf="productSalesCache[productKey(ba.baId, vg.categoryId, product.productId)]?.rows?.length"
                                      class="table table-sm mb-0 product-sales-table">
                                      <thead>
                                        <tr>
                                          <th>{{ 'KPI.ANALYTICS.DATE' | translate }}</th>
                                          <th>{{ 'KPI.ANALYTICS.TIME' | translate }}</th>
                                          <th>{{ 'KPI.ANALYTICS.BASKET_ID' | translate }}</th>
                                          <th>{{ 'KPI.ANALYTICS.STORE' | translate }}</th>
                                          <th class="text-end">{{ 'KPI.ANALYTICS.QUANTITY' | translate }}</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr *ngFor="let sale of productSalesCache[productKey(ba.baId, vg.categoryId, product.productId)].rows">
                                          <td>{{ formatOrderDate(sale.orderDate) }}</td>
                                          <td>{{ formatOrderTime(sale.orderDate) }}</td>
                                          <td>{{ sale.orderNumber }}</td>
                                          <td>{{ sale.storeName || sale.storeId }}</td>
                                          <td class="text-end">{{ formatNumber(sale.quantity) }}</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                    <div *ngIf="productSalesCache[productKey(ba.baId, vg.categoryId, product.productId)]?.pagination
                                      && productSalesCache[productKey(ba.baId, vg.categoryId, product.productId)].currentPage < productSalesCache[productKey(ba.baId, vg.categoryId, product.productId)].pagination.totalPages"
                                      class="text-center py-2">
                                      <button type="button" class="btn btn-sm btn-outline-primary"
                                        [disabled]="productSalesCache[productKey(ba.baId, vg.categoryId, product.productId)]?.loading"
                                        (click)="loadMoreProductSales(ba.baId, vg.categoryId, product.productId); $event.stopPropagation()">
                                        <span *ngIf="productSalesCache[productKey(ba.baId, vg.categoryId, product.productId)]?.loading && productSalesCache[productKey(ba.baId, vg.categoryId, product.productId)]?.rows?.length">
                                          <nb-spinner size="tiny"></nb-spinner>
                                        </span>
                                        <span *ngIf="!(productSalesCache[productKey(ba.baId, vg.categoryId, product.productId)]?.loading && productSalesCache[productKey(ba.baId, vg.categoryId, product.productId)]?.rows?.length)">
                                          {{ 'KPI.ANALYTICS.LOAD_MORE' | translate }}
                                        </span>
                                      </button>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </ng-container>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </ng-container>
                <tr *ngIf="!ba.varegrupper?.length">
                  <td colspan="4" class="text-center text-muted py-3">{{ 'KPI.CHAIN_REPORTS.NO_VAREGRUPPER' | translate }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </nb-card-body>
  </nb-card>
</div>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="large" [fullScreen]="true" color="white" type="ball-circus">
  <p style="color: white">{{ 'KPI.CHAIN_REPORTS.LOADING' | translate }}</p>
</ngx-spinner>
